import { BaseService } from '../../infra/base.service'
import { Store } from '../../infra/store.service'
import { AuthRepository } from '../auth/auth.repository'
import { AuthService } from '../auth/auth.service'
import type { CompaniesRepository } from './companies.repository'
import type { AllowedHoursEntity, Company } from './company'

export class CompaniesService extends BaseService<Company> {
    getTimezones() {
        const timezones: { label: string; value: number }[] = []
        timezones.push({ value: 120, label: '(UTC+02:00) Leste Europeu' })
        timezones.push({ value: 60, label: '(UTC+01:00) Europa Central' })
        timezones.push({ value: 0, label: '(UTC+00:00) Europa Ocidental' })
        timezones.push({ value: -60, label: '(UTC-01:00) Portugal - Açores' })
        timezones.push({ value: -120, label: '(UTC-02:00) Fernando de Noronha' })
        timezones.push({ value: -180, label: '(UTC-03:00) Brasília' })
        timezones.push({ value: -240, label: '(UTC-04:00) Amazonas' })
        timezones.push({ value: -300, label: '(UTC-05:00) Acre' })
        timezones.push({ value: -360, label: '(UTC-06:00) Padrão Central' })
        return timezones
    }
    private store: Store
    constructor(
        private compRep: CompaniesRepository,
        private companyId?: string,
    ) {
        super(compRep)
        this.store = new Store()
    }

    // permite injetar companyId explicitamente (backend/multi-tenant); no browser cai no comportamento de sempre (Store/localStorage)
    private get resolvedCompanyId(): string {
        return this.companyId || this.store.company?.['companyId']
    }

    async getAlert(key: string) {
        return await this.compRep.getAlert(key)
    }

    async getPublicCompany(companyId: string) {
        return await this.compRep.getPublicCompany(companyId)
    }

    async confidenceUnlock(companyId: string) {
        return await this.compRep.confidenceUnlock(companyId)
    }

    async delayCardRenew(companyId: string) {
        return await this.compRep.delayCardRenew(companyId)
    }

    updateAppVersion() {
        const current = window.api.utils.utils.getCookie('appVersion')
        if (this.store?.company && current !== this.store?.company?.appVersion) {
            window.api.utils.utils.setCookie('appVersion', this.store?.company?.appVersion, 365)
        }
    }

    async getCompanyUsers(useCacheIfNewerThanThisInSeconds: number = 0) {
        return await this.compRep.getCompanyUsers(this.resolvedCompanyId, useCacheIfNewerThanThisInSeconds)
    }

    async assignUser(companyId: string, userId: string) {
        await this.compRep.assignUser(companyId, userId)
    }

    async setAllowLogin(userId: string, allowLogin: boolean, allowedHours: AllowedHoursEntity) {
        return await this.compRep.setAllowLogin(userId, allowLogin, allowedHours)
    }

    async getAllowLogin(userId: string) {
        return await this.compRep.getAllowLogin(userId)
    }

    async removeUser(companyId: string, userId: string) {
        await this.compRep.removeUser(companyId, userId)
    }

    async setCurrent(companyId: any) {
        const company = await this.getOne(companyId)
        if (!company) {
            window.log('setCurrent failed. company was null for companyId ' + companyId, 'debug', { context: 'companies.service.ts' })
            return null
        }
        this.store.company = company // esse store.company é usado pelo device para recuperar o jwt token
        this.updateAppVersion()
        // todo: refatorar e tirar essa chamada daqui
        const authS = new AuthService(new AuthRepository())
        await authS.getCompanyToken(companyId, this.store.token.token)
        return this.store.company
    }

    async getCurrent() {
        return this.store.company
    }
}
